import { createSlice } from "@reduxjs/toolkit";

export const sharedSlice = createSlice({
  name: "shared",
  initialState: {
    generalParameters: {},
  },
  reducers: {
    addGeneralParams: (state, action) => {
      state.generalParameters.countryCurrency =
        action.payload.countryCurrency.reduce(
          (prev, current) => ({ ...prev, [current.id]: current.label }),
          {}
        );
      state.generalParameters.countryCurrencyPosition =
        action.payload.countryCurrency.reduce(
          (prev, current) => ({ ...prev, [current.id]: current.position }),
          {}
        );
      state.generalParameters.requestState = action.payload.requestState.reduce(
        (prev, current) => ({ ...prev, [current.id]: current.label }),
        {}
      );
      state.generalParameters.solutionStatus =
        action.payload.solutionStatus.reduce(
          (prev, current) => ({ ...prev, [current.id]: current.label }),
          {}
        );
      state.generalParameters.solutionTransportType =
        action.payload.solutionTransportType.reduce(
          (prev, current) => ({ ...prev, [current.id]: current.label }),
          {}
        );

      state.generalParameters.contactOperationalType =
        action.payload.contactOperationalType;
      state.generalParameters.countryList = action.payload.countryList;
      state.generalParameters.categoryList = action.payload.categoryList;
      state.generalParameters.subCategoryList = action.payload.subCategoryList;
      state.generalParameters.unitList = action.payload.unitList;
      state.generalParameters.coordinates = action.payload.coordinates;
      state.generalParameters.mainCurrencyList =
        action.payload.mainCurrencyList;
      state.generalParameters.userCurrencyList =
        action.payload.userCurrencyList;
    },
    addDepartment: (state, action) => {
      state.generalParameters.departmentList = action.payload.department;
    },
    addSector: (state, action) => {
      const listObj = [];
      action.payload.activity.map((data) => {
        listObj.push({ value: data.id, label: data.name });
      });
      state.generalParameters.sectorList = listObj;
    },
    addCentreRecyclingCodes: (state, action) => {
      const listObj = [];
      action.payload.centreRecyclingCodes.map((data) => {
        listObj.push({ value: data.id, label: data.code });
      });
      state.generalParameters.centreRecyclingCodes = listObj;
    },
  },
});

export const {
  addGeneralParams,
  addDepartment,
  addSector,
  addCentreRecyclingCodes,
} = sharedSlice.actions;

export default sharedSlice.reducer;
